import { useMutation } from "@tanstack/react-query";
import { Account } from "api/types/Account";
import ImportForm, { Import } from "components/forms/import-form";
import PaneNavigator from "components/ui/pane-navigator";
import { PaneNavigatorHandle } from "components/ui/pane-navigator/pane-navigator";
import { useStore } from "hooks";
import { useCallback, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import SelectAccount from "./select-account";

export function ImportModal() {
  const navigate = useNavigate();
  const navigator = useRef<PaneNavigatorHandle>(null);
  const { id } = useParams();
  const { profileStore } = useStore();
  const [data, setData] = useState<Partial<Import>>({});
  const { isSuccess, mutate } = useMutation({
    mutationFn: profileStore.import,
  });

  const handleSubmit = (values: Import) => {
    // /* @ts-ignore */
    mutate(
      {
        accountId: values.account.id,
        file: values.file,
        delimiter: values.delimiter,
      },
      {
        onError: (error) => {
          alert("error importing");
        },
      }
    );
  };

  const goBack = () => {
    navigator.current?.goBack();
  };

  const handleAccountChange = (account: Account) => {
    setData({ ...data, account: account });
    goBack();
  };

  const handleDelimiterChange = (delimiter: string) => {
    setData({ ...data, delimiter });
  };

  const openSelectAccount = () => {
    navigator.current?.navigateTo(
      <SelectAccount onChange={handleAccountChange} onCancel={goBack} />
    );
  };

  const handleFileChange = useCallback(
    (file: File) => {
      if (file) {
        setData({ ...data, file });
      }
    },
    [setData, data]
  );

  return (
    <>
      {isSuccess ? "Success" : null}
      <PaneNavigator ref={navigator}>
        <ImportForm
          data={data}
          onCancel={() => navigate(-1)}
          onSubmit={handleSubmit}
          onAccountClick={openSelectAccount}
          onFileChange={handleFileChange}
          onDelimiterChange={handleDelimiterChange}
        />
      </PaneNavigator>
    </>
  );
}
